import { LoadUserLocationList } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { UserLocation } from '@/javascript/domain/entities/maps/user-location'
import { ListMapper } from '@/javascript/infra/mappers/mapper'
import { HttpClient, HttpStatusCode } from '@/javascript/data/protocols/http'
import { RemoteUserLocation } from '@/javascript/data/entities/maps/remote-user-location'

export class RemoteLoadUserLocationList implements LoadUserLocationList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadUserLocationList.Response>,
    private readonly userLocationMapper: ListMapper<UserLocation, RemoteUserLocation>
  ) {}

  async load(params?: LoadUserLocationList.Params): Promise<UserLocation[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        q: params?.searchText,
        resource_place_ids: params?.resourcePlaces,
        form_ids: params?.forms,
        project_ids: params?.projects,
        provider_ids: params?.providers,
        inspector_ids: params?.inspectors,
        status: params?.status,
        work_finish_option_ids: params?.finishOptions
      }
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok: return this.userLocationMapper.toEntityList(response?.user_locations) ?? []
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadUserLocationList {
  export type Response = {
    user_locations?: RemoteUserLocation[]
  }
}
